import { useQuery } from "@tanstack/react-query";
import { fetchHeroCommercialMerchandising } from "../api/heroCommercialApi";

// Partagé avec le serveur (prefetch SSR de la home) : même clé des deux côtés, pour que le
// client hydrate le hero depuis window.__REACT_QUERY_STATE__ sans le re-télécharger.
export const getHeroCommercialMerchandisingQuery = ({
	code,
	shop,
	productsVisibility,
	partnerCode,
}) => ({
	queryKey: ["heroCommercial", "merchandising", code, shop, productsVisibility, partnerCode],
	queryFn: () =>
		fetchHeroCommercialMerchandising({ code, shop, productsVisibility, partnerCode }),
	staleTime: 1000 * 60 * 5,
});

export const useHeroCommercialMerchandising = ({ code, shop, productsVisibility, partnerCode }) =>
	useQuery({
		...getHeroCommercialMerchandisingQuery({ code, shop, productsVisibility, partnerCode }),
		enabled: Boolean(code),
	});
